import loginApi from "./login-api";
import loader from "../../utils/loader";
import deleteQueryParameterAfterUsed from "../../utils/delete-query-parameter-after-used";
import usPhoneNumberFormatter from "../../utils/format-us-phone";
import Swal from "sweetalert2";

const $eyeToggleContainer = $('.eye-toggle-container');
const $btnForgotPassword = $('#btn-forgot-password');
const $customDialogClose = $('.custom-dialog-close');
const $newPasswordDialogClose = $('.new-password-dialog-close');
const $forgotPasswordMessageDialog = $('#forgot-password-message-dialog');
const $forgotPasswordLabelHeader = $('.forgot-password-label-header');
const $newPasswordDialog = $('#new-password-dialog');
const $newPasswordMessageDialog = $('#new-password-message-dialog');
const $btnClose = $('.btn-dialog-close');
const $forgotPasswordForm = $('#forgot-password-form');
const $newPasswordForm = $('#new-password-form');
const $forgotEmail = $('#forgot-email-field');
const $resetPasswordBtn = $('.reset-password')
const $emailError = $('#email-error');
const $newPasswordToken = $('#new-password-token-field');
const $newPasswordEmail = $('#new-password-email-field');
const $newPasswordLabel = $('.forgot-password-label');
const $textMeOTP = $('.text-me-otp');
const $phoneLogin = $('#phone-login-dialog');
const $phoneLoginBtnClose = $('.phone-login-dialog-close');
const $phoneLoginForm = $('#phone-login-form');
const $phoneLoginSendBtn = $('.phone-login-send-btn');
const $phoneLoginError = $('.phone-login-error');
const $otpDialog = $('#otp-dialog');
const $otpDialogBtnClose = $('.otp-dialog-close');
const $otpDialogForm = $('#otp-form');
const $otpDialogLoginBtn = $('.otp-btn');
const $otpDialogError = $('.otp-error');
const $timerLabel = $('.timer');
const $resendOTP = $('.re-send-otp');
const $otpTimer = $('.otp-timer');
const $editPhone = $('.edit-phone');
const $phoneNumberUsed = $('.phone-number-used');
const $otpInput = $('.otp-input');

let phone = '';
let timer = 180;
let interval;

const {
  forgotPasswordApi,
  changePasswordApi,
  sendOTPApi,
  validateOTPApi,
  markAsUsedApi,
} = loginApi();

const {
  renderButtonLoader,
  loggingInButtonLoader,
} = loader();

$(function () {
  let signInOption = 'email';

  /*------------------ Events -----------------*/
  $('#login-with-phone-btn').on('click', function () {
    signInOption = 'phone';
    showHideLoginOption('login-with-phone', ['login-with-email', 'forgot-password']);
  });

  $('#login-with-email-btn').on('click', function () {
    signInOption = 'email';
    showHideLoginOption('login-with-email', ['login-with-phone', 'forgot-password']);
  });

  $('#forgot-password-btn').on('click', function () {
    showHideLoginOption('forgot-password', ['login-with-phone', 'login-with-email']);
  });

  $('#send-otp').on('click', function () {
    $(this).addClass('d-none');
    $('.login-with-phone-otp').removeClass('d-none');
    $('#login-btn').removeClass('d-none');
  });

  $('.back-to-login').on('click', function () {
    showHideLoginOption('login-with-email', ['login-with-phone', 'forgot-password']);
  });

  $('#email').on('keyup', function (e) {
    $(this).removeClass('is-invalid');
    $(this).next().remove();
  });

  $('#password').on('keyup', function (e) {
    $(this).removeClass('is-invalid');
    // $(this).next().remove();
  });

  $('.numbers-only').on('keyup', function (e) {
    // const id = $(this).attr('id');
    numbersOnly($(this));
  });

  /*------------------ End Events -----------------*/

  /*------------------ Functions -----------------*/
  const showHideLoginOption = (targetClass, hideClasses) => {
    hideClasses.forEach((hideClass) => {
      $('.' + hideClass).addClass('d-none');
      if (targetClass !== 'forgot-password') {
        $('#' + hideClass + '-btn').removeClass('d-none');
      } else {
        $('#' + hideClass + '-btn').addClass('d-none');
      }
    });
    $('.' + targetClass).removeClass('d-none');
    $('#' + targetClass + '-btn').addClass('d-none');

    //reset otp value
    if (targetClass === 'login-with-email' || targetClass === 'forgot-password') {
      resetOtpValue();
      $('.login-with-phone-otp').addClass('d-none');

      if (targetClass === 'forgot-password') {
        $('#login-btn').addClass('d-none');
      } else {
        $('#login-btn').removeClass('d-none');
      }
    } else {
      $('#login-btn').addClass('d-none');
    }

    //change label
    if (targetClass === 'forgot-password') {
      $('.login-footer-btn-separator').addClass('d-none');
      $('.login-form-label').text('Forgot Password');
      $('.back-to-login').removeClass('d-none');
      $('.login-logo').addClass('d-none');
    } else {
      $('.login-footer-btn-separator').removeClass('d-none');
      $('.login-form-label').text('Login');
      $('.login-logo').removeClass('d-none');
      $('.back-to-login').addClass('d-none');
    }
  }

  const resetOtpValue = () => {
    $('#otp-digit-1').val('');
    $('#otp-digit-2').val('');
    $('#otp-digit-3').val('');
    $('#otp-digit-4').val('');
    $('#otp-digit-5').val('');
    $('#otp-digit-6').val('');
  }

  //make common function
  const numbersOnly = (element) => {
    const value = element.val();
    const newValue = value.replace(/[^0-9]/g, '');
    element.val(newValue);
  }
  /*------------------ End Functions -----------------*/
});

$eyeToggleContainer.on('click', function () {
  const $input = $(this).prev();
  const type = $input.attr('type');
  if (type === 'password') {
    $input.attr('type', 'text');
    $(this).find('i.fa-eye').removeClass('d-none');
    $(this).find('img.eye-closed').addClass('d-none');
  } else {
    $input.attr('type', 'password');
    $(this).find('i.fa-eye').addClass('d-none');
    $(this).find('img.eye-closed').removeClass('d-none');
  }
});

$btnForgotPassword.on('click', function () {
  $('#forgotPasswordDialog').showDialog();
});

$customDialogClose.on('click', function () {
  $('#forgotPasswordDialog').closeDialog();
});

$newPasswordDialogClose.on('click', function () {
  $newPasswordDialog.closeDialog();
  $newPasswordLabel.text('Change Password');
});

$btnClose.on('click', function () {
  $('#forgotPasswordDialog').closeDialog();
});

$textMeOTP.on('click', function () {
  $phoneLogin.showDialog();
});

$phoneLoginBtnClose.on('click', function () {
  $phoneLogin.closeDialog();
});

$otpDialogBtnClose.on('click', function () {
  $otpDialog.closeDialog();
  $otpDialogForm[0].reset();
  $otpDialogError.text('');
});

$newPasswordMessageDialog.on('click', '.btn-dialog-close', function () {
  $newPasswordMessageDialog.find('.custom-dialog-content').removeClass('open').addClass('closed');
  setTimeout(() => {
    $newPasswordMessageDialog.addClass('d-none');
  }, 300);
});

$forgotEmail.on('keyup', function () {
  $emailError.text('');
});

$forgotPasswordForm.on('submit', async function (e) {
  e.preventDefault();
  const originalButton = $resetPasswordBtn.html();
  $resetPasswordBtn.html(renderButtonLoader());
  const formData = new FormData(this);
  try {
    const apiResponse = await forgotPasswordApi(formData);

    //reset form values
    $(this)[0].reset();

    //close forgot password dialog
    $('#forgotPasswordDialog').closeDialog();
    if (apiResponse && apiResponse === 'throttled') {
      //open too many attempt dialog
      $forgotPasswordLabelHeader.text('Too many attempts');
      $forgotPasswordMessageDialog.showDialog();
    } else {
      //open forgot password message dialog
      $forgotPasswordLabelHeader.text('Your password reset request has been processed');
      $forgotPasswordMessageDialog.showDialog();
    }
  } catch (catchedError) {
    let errorData = catchedError.response.data.error;
    if (typeof errorData === 'string') {
      try {
        let parsedErrorData = JSON.parse(errorData);
        let errorMessages = Object.values(parsedErrorData)
          .flat()
          .map(messages => messages)
          .join('');

        $emailError.text(errorMessages);
      } catch (e) {
        $emailError.text(errorData);
      }
    }
  }
  $resetPasswordBtn.html(originalButton);
});

$newPasswordForm.on('submit', async function (e) {
  e.preventDefault();
  const originalButton = $resetPasswordBtn.html();
  $resetPasswordBtn.html(renderButtonLoader());
  const formData = new FormData(this);
  try {
    const response = await changePasswordApi(formData);
    //reset form values
    $(this)[0].reset();
    $newPasswordLabel.text('Change Password');


    if (!response) {
      const message = `Unable to change password, please contact support`;
      $('#password-error').html(message);
      $resetPasswordBtn.html(originalButton);
      return;
    }

    //close forgot password dialog
    $newPasswordDialog.closeDialog();

    $newPasswordMessageDialog.showDialog();

  } catch (catchedError) {
    let errorData = catchedError.response.data.error;
    if (!errorData){
      const message = `<div class="mt-2">Unable to change password
        <ul>
          <li>At least 8 characters long</li>
          <li>At least one uppercase letter</li>
          <li>At least one lowercase letter</li>
          <li>At least one number</li>
        </ul>
      </div>`;
      $('#password-error').html(message);
    } else if (typeof errorData === 'string') {
      try {
        let parsedErrorData = JSON.parse(errorData);
        let errorMessages = Object.values(parsedErrorData)
          .flat()
          .map(messages => `<li>${messages}</li>`)
          .join('');

        $('#password-error').html(`<ul>${errorMessages}</ul>`);
      } catch (e) {
        $('#password-error').text(errorData);
      }
    }
  }
  $resetPasswordBtn.html(originalButton);
});

$resendOTP.on('click', async function(e) {
  const originalButton = $(this).html();
  $(this).html(renderButtonLoader());
  try {
    const formData = new FormData();
    // const phone = $otpDialogForm.find('input[name="phone"]').val();
    formData.append('phone', phone);
    formData.append('resend', true);
    const response = await sendOTPApi(formData);
    if(!response.success) {
      $otpDialogError.text(response.message);
      setTimeout(function() {
        $otpDialogError.text('');
      }, 3500);
    }
    $(this).html(originalButton);
    $(this).addClass('d-none');
    $otpTimer.removeClass('d-none');
    setOtpResendTimer();
  } catch (catchedError) {
    let errorData = catchedError.response.data.error;
    if (typeof errorData === 'string') {
      try {
        let parsedErrorData = JSON.parse(errorData);
        let errorMessages = Object.values(parsedErrorData)
          .flat()
          .map(messages => messages)
          .join('');

        $otpDialogError.text(errorMessages);
      } catch (e) {
        $otpDialogError.text(errorData);
      }
    }
  }

});

$phoneLoginForm.on('submit', async function (e) {
  e.preventDefault();
  const originalButton = $phoneLoginSendBtn.html();
  $phoneLoginSendBtn.html(renderButtonLoader());

  const formData = new FormData(this);
  phone = formData.get('phone').replace(/[^\d]/g, '');
  formData.set('phone', phone);

  //sweet alert
  Swal.fire({
    title: 'Confirm Phone number',
    html: 'Is the phone number correct? <br> <strong>' + usPhoneNumberFormatter(phone).formatted + '</strong>',
    showDenyButton: true,
    confirmButtonText: 'Yes',
    denyButtonText: `No`,
    allowOutsideClick: false
  }).then(async (result) => {
    if (result.isConfirmed) {
      await submitSendOtp(formData);
      $phoneLoginSendBtn.html(originalButton);
    } else {
      $phoneLoginSendBtn.html(originalButton);
    }

  });
});

const submitSendOtp = async (formData) => {
  try {
    await sendOTPApi(formData);
    //reset form values
    $phoneLoginForm[0].reset();

    //close forgot password dialog
    $phoneLogin.closeDialog();

    //open forgot password message dialog
    const number = usPhoneNumberFormatter(phone);
    $phoneNumberUsed.text(number.formatted.replace(/\s+/g, '-').replace(/-+/g, '-'));
    $otpDialogForm.find('input[name="phone"]').val(phone);

    $otpDialog.showDialog();
    setOtpResendTimer();
  } catch (catchedError) {
    let errorData = catchedError.response.data.error;
    if (typeof errorData === 'string') {
      try {
        let parsedErrorData = JSON.parse(errorData);
        let errorMessages = Object.values(parsedErrorData)
          .flat()
          .map(messages => messages)
          .join('');

        $phoneLoginError.text(errorMessages);
      } catch (e) {
        $phoneLoginError.text(errorData);
      }
    }
  }
}

$editPhone.on('click', async function() {
  const originalButton = $(this).html();
  $(this).html(renderButtonLoader());
  await markAsUsedApi({phone: phone});
  $otpDialogForm[0].reset();
  $otpDialogError.text('');
  $phoneLogin.showDialog();
  $otpDialog.closeDialog();
  $(this).html(originalButton);
});

$otpInput.on('input', function() {
  const value = $(this).val();
  const newValue = value.replace(/[^0-9]/g, '');
  if(newValue) {
    $(this).val(newValue);
    if ($(this).val() && $(this).next('.otp-input').length) {
      $(this).next('.otp-input').focus();
  }
  }
});

$otpDialogForm.on('submit', async function (e) {
  e.preventDefault();
  const originalButton = $otpDialogLoginBtn.html();
  $otpDialogLoginBtn.html(renderButtonLoader());
  const otpInputs = $('.otp-input');
  let otp = '';
  otpInputs.each(function() {
      otp += $(this).val();
  });

  const otpValidationData = {
    phone: phone,
    otp: otp,
  }
  try {
    const response = await validateOTPApi(otpValidationData);
    if (!response.success) {
      $otpDialogError.text(response.message);
      $otpDialogLoginBtn.html(originalButton);
      return;
    }
    window.location.reload();

  } catch (catchedError) {
    let errorData = catchedError.response.data.error;
    if (typeof errorData === 'string') {
      try {
        let parsedErrorData = JSON.parse(errorData);
        let errorMessages = Object.values(parsedErrorData)
          .flat()
          .map(messages => messages)
          .join('');

        $otpDialogError.text(errorMessages);
      } catch (e) {
        $otpDialogError.text(errorData);
      }
    }
  }
  $otpDialogLoginBtn.html(originalButton);
});

const populateNewPasswordFields = (token, email) => {
  $newPasswordToken.val(token);
  $newPasswordEmail.val(email);
}
const checkURLParams = () => {
  const url = new URL(window.location.href);
  const setupToken = url.searchParams.get('setup_token');
  let email = url.searchParams.get('email');
  if (setupToken && email) {
    const next = new URL('/invitation/access', window.location.origin);
    next.searchParams.set('setup_token', setupToken);
    next.searchParams.set('email', email);
    window.location.replace(next.toString());
    return;
  }
  const legacyToken = url.searchParams.get('token');
  if (legacyToken && email) {
    email = email.replace(/ /g, '+');
    populateNewPasswordFields(legacyToken, email);
    $newPasswordLabel.text('Change Password');
    $newPasswordDialog.showDialog();
    deleteQueryParameterAfterUsed(url, ['token', 'email']);
  }
}

const setOtpResendTimer = () => {
  if (interval) {
    clearInterval(interval);
  }
  timer = 180;
  interval = setInterval(function() {
    timer--;
    const minutes = Math.floor(timer / 60);
    const seconds = timer % 60;
    const timeString = minutes > 0 ? `${minutes}m ${seconds}s` : `${seconds}s`;
    $timerLabel.text(timeString);
    if (timer === 0) {
      clearInterval(interval);
      $resendOTP.removeClass('d-none');
      $otpTimer.addClass('d-none');
      timer = 180;
    }
  }, 1000);
}

checkURLParams();

$('#new-password-field').on('input', function () {
  let password = $(this).val();
  let lengthValid = password.length >= 8;
  let uppercaseValid = /[A-Z]/.test(password);
  let numberValid = /[0-9]/.test(password);
  let specialValid = /[!@#$%^&*]/.test(password);
  let commonPatterns = /(password|1234|default|qwerty|admin|letmein|welcome)/i;

  if (password === "") {
    $('#length, #uppercase, #number, #special').removeClass('valid').addClass('invalid');
    $('#strength-text').text('Weak');
    $('#strength-bar').css('width', '0%').removeClass('weak medium strong');
    $('.reset-password').prop('disabled', true);
    return;
  }

  if (lengthValid) {
    $('#length').removeClass('invalid').addClass('valid');
  } else {
    $('#length').removeClass('valid').addClass('invalid');
  }

  if (uppercaseValid) {
    $('#uppercase').removeClass('invalid').addClass('valid');
  } else {
    $('#uppercase').removeClass('valid').addClass('invalid');
  }

  if (numberValid) {
    $('#number').removeClass('invalid').addClass('valid');
  } else {
    $('#number').removeClass('valid').addClass('invalid');
  }

  if (specialValid) {
    $('#special').removeClass('invalid').addClass('valid');
  } else {
    $('#special').removeClass('valid').addClass('invalid');
  }

  let strengthScore = 0;
  if (lengthValid) strengthScore += 1;
  if (uppercaseValid) strengthScore += 1;
  if (numberValid) strengthScore += 1;
  if (specialValid) strengthScore += 1;

  if (commonPatterns.test(password) || /(\d)\1\1/.test(password)) {
    strengthScore = 0;
  }

  let strengthText = 'Weak';
  let strengthBarWidth = '25%';
  let strengthClass = 'weak';

  if (strengthScore === 2) {
    strengthText = 'Medium';
    strengthBarWidth = '50%';
    strengthClass = 'medium';
  } else if (strengthScore === 3) {
    strengthText = 'Strong';
    strengthBarWidth = '75%';
    strengthClass = 'strong';
  } else if (strengthScore === 4) {
    strengthText = 'Very Strong';
    strengthBarWidth = '100%';
    strengthClass = 'strong';
  }

  $('#strength-text').text(strengthText);
  $('#strength-bar').css('width', strengthBarWidth);
  $('#strength-bar').removeClass('weak medium strong').addClass(strengthClass);

  // Enable/Disable submit button based on all requirements being met
  if (strengthScore === 4) {
    $('.reset-password').prop('disabled', false);
  } else {
    $('.reset-password').prop('disabled', true);
  }
});

$('#login-form').on('submit', function (e) {
  e.preventDefault();
  const form = this;
  const submitButton = $(form).find('button[type="submit"]');
  const siteKeyInput = $('#recaptcha-site-key');
  const siteKey = siteKeyInput.length > 0 && siteKeyInput.val() ? siteKeyInput.val().trim() : null;

  // Check visibility - look for email input field specifically
  const emailInput = $('#email');
  const phoneInput = $('#phone_number');
  const forgotPasswordInput = $('#forgot-email');

  const isEmailMode = emailInput.length > 0 && emailInput.is(':visible');
  const isPhoneMode = phoneInput.length > 0 && phoneInput.is(':visible');
  const isForgotPasswordMode = forgotPasswordInput.length > 0 && forgotPasswordInput.is(':visible');

  // Only execute reCAPTCHA Enterprise if site key is configured and we're in email login mode
  if (siteKey && isEmailMode && !isPhoneMode && !isForgotPasswordMode) {
    if (typeof grecaptcha !== 'undefined' && grecaptcha.enterprise && grecaptcha.enterprise.ready) {
      grecaptcha.enterprise.ready(function() {
        grecaptcha.enterprise.execute(siteKey, {action: 'LOGIN'}).then(function(token) {
          $('#g-recaptcha-response').val(token);
          submitButton.html(loggingInButtonLoader()).prop('disabled', true).css('text-transform', 'none');
          form.submit();
        }).catch(function(error) {
            console.error('reCAPTCHA Enterprise error:', error);
            // If reCAPTCHA fails, submit without it (but backend will handle it)
            submitButton.html(loggingInButtonLoader()).prop('disabled', true).css('text-transform', 'none');
            form.submit();
        });
      });
    } else {
      // If reCAPTCHA script hasn't loaded yet, wait a bit and try again
      if (typeof grecaptcha === 'undefined' || !grecaptcha.enterprise) {
        setTimeout(function() {
          if (typeof grecaptcha !== 'undefined' && grecaptcha.enterprise && grecaptcha.enterprise.ready) {
            grecaptcha.enterprise.ready(function() {
              grecaptcha.enterprise.execute(siteKey, {action: 'LOGIN'}).then(function(token) {
                $('#g-recaptcha-response').val(token);
                submitButton.html(loggingInButtonLoader()).prop('disabled', true).css('text-transform', 'none');
                form.submit();
              }).catch(function(error) {
                console.error('reCAPTCHA Enterprise error:', error);
                submitButton.html(loggingInButtonLoader()).prop('disabled', true).css('text-transform', 'none');
                form.submit();
              });
            });
          } else {
            // Still not loaded, submit without reCAPTCHA
            submitButton.html(loggingInButtonLoader()).prop('disabled', true).css('text-transform', 'none');
            form.submit();
          }
        }, 500);
      } else {
        // reCAPTCHA not available, submit without it
        submitButton.html(loggingInButtonLoader()).prop('disabled', true).css('text-transform', 'none');
        // form.submit();
      }
    }
  } else {
    // No reCAPTCHA needed (phone login or forgot password) - but still submit the form
    submitButton.html(loggingInButtonLoader()).prop('disabled', true).css('text-transform', 'none');
    form.submit();
  }
});
